import { createSlice } from '@reduxjs/toolkit'

export const otpReducer = createSlice({
  name: 'otp',
  initialState:{
    value:false
  },
  reducers: {
    sendOtp: (state) => {
      state.value = true
    },
   
  },
})

export const { sendOtp } = otpReducer.actions

export default otpReducer.reducer